import React from 'react';
import { ProgressBadge } from '../../../components/ProgressBadge/ProgressBadge.component';
import { Status } from '../../../services/exams/assessmentSession/assessments.types';
import SendbackRGZButton from '../SendbackRGZButton/SendbackRGZButton.component';
import EnvWindow from '../../../utils/env';

export const getProgress = (
  progress: number,
  status: Status,
  examinerId: string,
  examTaskGroupSolutionScoreIds?: string[],
  sendbackFunction?: (arg: string[]) => void,
  isExceptionalCase?: boolean,
  forceSimpleView?: boolean,
): JSX.Element => {
  const auth = JSON.parse(sessionStorage.getItem(`oidc.user:${EnvWindow.REACT_APP_AUTHORITY_URL}:ckeone_react`)!);

  if (!forceSimpleView && status === Status.Open && progress === 100 && auth.profile.sub === examinerId)
    return (
      <SendbackRGZButton
        buttonType="single"
        isDisabled={isExceptionalCase}
        isSpecialCaseReported={isExceptionalCase}
        examTaskGroupSolutionScoreIds={examTaskGroupSolutionScoreIds}
        sendbackFunction={sendbackFunction}
      />
    );
  else return <ProgressBadge progress={progress} />;
};
